<template>
  <div class="wrapper">
    <side-bar>
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link v-for="(link, index) in sidebarLinks" :key="index" :to="link.to">
        <a v-if="link.submenu" @mouseover="toggleMenu(index)">
          <i :class="link.icon"></i>
          <p class="sidebar-inter">{{ link.label }}
            <!-- <i  :class="isMenuOpen === index ? 'nc-icon nc-stre-down text-light font-weight-bold pt-2' : 'nc-icon nc-stre-right text-light font-weight-bold pt-2'"
              style="font-size: 15px !important;"></i> -->
          </p>
        </a>
        <!-- Verificamos si hay un submenu y lo generamos si es necesario -->
        <ul class="submenu text-light" v-if="isMenuOpen === index">
          <li v-for="(sublink, subIndex) in link.submenu" :key="subIndex">
            <router-link :to="sublink.to" class="font-weight-bold" style=" color: #FFFFFF;">
              {{ sublink.label }}
            </router-link>
          </li>
        </ul>
      </sidebar-link>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content @click="toggleSidebar"></dashboard-content>
      <content-footer></content-footer>
    </div>
  </div>
</template>

<script>
import TopNavbar from './TopNavbar.vue'
import ContentFooter from './ContentFooter.vue'
import DashboardContent from './Content.vue'
import MobileMenu from './MobileMenu.vue'

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu
  },
  data() {
    return {
      isMenuOpen: -1, // Inicialmente ningun submenu abierto
      // Definimos los enlaces en un arreglo
      sidebarLinks: [
  //     { 
  //   to: '/admin/overview', 
  //   icon: 'nc-icon nc-tv-2', 
  //   label: 'Inicio', 
  //   submenu:[]
  // },
        {
          to: '',
          icon: 'nc-icon nc-delivery-fast',
          label: 'Mis Inspecciones',
          to: '/admin/inspections',
          submenu: [
            // { to: '/admin/users/admins', label: 'Administradores' },
            // { to: '/admin/users/drivers', label: 'Conductoras' },
            // { to: '/admin/users/riders', label: 'Representantes' },
            // { to: '/admin/users/children', label: 'Chamis' },
          ]
        },
        {
          to: '',
          icon: 'nc-icon nc-circle-09',
          label: 'Perfil',
          to: '/admin/profile',
          submenu: [
            // { to: '/admin/vehicles', label: 'Vehículos' },
            // { to: '/admin/services', label: 'Servicios' },
            // { to: '/admin/routes', label: 'Rutas' },
            // { to: '/admin/locations', label: 'Institución' },
          ]
        },
        // {
        //   to: '',
        //   icon: 'nc-icon nc-money-coins',
        //   label: 'Finanzas',
        //   submenu: [
        //     { to: '/admin/paymentsd', label: 'Pagos conductoras' },
        //     { to: '/admin/paymentsr', label: 'Pagos recibidos' },
        //     { to: '/admin/subscription', label: 'Membresías' },

        //   ]
        // },
        // {
        //   to: '',
        //   icon: 'nc-icon nc-preferences-circle-rotate',
        //   label: 'Configurar',
        //   submenu: [
        //     { to: '/admin/configurations', label: 'Maestros' },
        //     { to: '/admin/banks', label: 'Bancos' },
        //     { to: '/admin/documents', label: 'Documentos' },
        //     { to: '/admin/documentsType', label: 'Tipos de doc' },
        //   ]
        // },
      ]
    }
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    },
    toggleMenu(index) {
      this.isMenuOpen = this.isMenuOpen === index ? -1 : index;
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap');

.sidebar-inter {
  font-family: 'Ubuntu', sans-serif;
  /* font-weight: 600; */
  color: #FFFFFF;
}
</style>